module.exports = __webpack_public_path__ + "static/media/video-bg.6a94619c.jpg";